import { t } from "i18next";

import { getLocationType } from "@models/services/organisation";

export const tabItems = (locationDetails: getLocationType) => {
  const tabs = [
    {
      label: t("Booking"),
      name: "Booking",
      route: `/organisation-info/${locationDetails?.clubId}/booking`,
    },
    {
      label: t("Info"),
      name: "Info",
      route: `/organisation-info/${locationDetails?.clubId}/info`,
    },
  ];
  return tabs;
};
